import { AppModule } from '@app/app.module'
import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { environment } from '@env/environment'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { RUNTIME_CONFIG, loadRuntimeConfig } from '@config/runtime-config'

if (environment.production) {
    enableProdMode()

    if (typeof window !== 'undefined') {
        window.console.debug = () => {}
        window.console.log = () => {}
        window.console.info = () => {}
        window.console.warn = () => {}
    }
}

// As chaves de APIs externas (reCAPTCHA) são resolvidas antes do bootstrap para que o AppModule
// possa injetá-las via RUNTIME_CONFIG sem que precisem existir no bundle.
loadRuntimeConfig()
    .then(runtimeConfig =>
        // Sem isso o Angular 21 sobe sem zone.js, e o código (vindo do Angular 18) depende dela para
        // atualizar a tela depois de chamadas HTTP.
        platformBrowserDynamic([{ provide: RUNTIME_CONFIG, useValue: runtimeConfig }]).bootstrapModule(AppModule, {
            applicationProviders: [provideZoneChangeDetection()]
        })
    )
    .catch(err => console.error(err))
